import { ofType, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Auth from '../../api/auth';
import { requestFailed } from '../status/actions';

import { FETCH_USER_DATA_STARTED, fetchUserDataFulfilled } from './actions';

import type { User } from '@/types/user';

const fetchUserDataEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_USER_DATA_STARTED),
    mergeMap((action: { payload: unknown }) =>
      from(Auth.fetchV2Users(action.payload)).pipe(
        mergeMap((response: { data: Record<string, unknown>[] }) =>
          response.data[0] ? of(fetchUserDataFulfilled(response.data[0] as unknown as User)) : of(requestFailed())
        ),
        catchError(() => of(requestFailed()))
      )
    )
  );

export default fetchUserDataEpic;
